<template>
  <v-avatar left class="ma-2" :size="size || 44" @click="$emit('click')">
    <v-img :src="url" class="avatar-custom" contain></v-img>
  </v-avatar>
</template>

<script>
import api from "../../api.js";
export default {
  props: ["id", "size"],
  data: () => ({
    url: ""
  }),
  mounted() {
    this.url = this.id
      ? api.baseURL + "archive/" + this.id
      : require("@/assets/profile-default-male.png");
  }
};
</script>

<style>
.avatar-custom {
  border: 1px solid #0596de;
}
</style>
